import productTitleImg from "../../assets/images/base/text mahsolat.jpg";
import ProductItem from "./ProductItem";
import ProductModal from "./ProductModal";
import { useState } from "react";
export default function ProductList({ productListData, clickOnProduct, rout }) {
  const [showProductModal, setShowProductModal] = useState(false);
  const [productModalData, setProductModalData] = useState([]);
  const closeModal = () => {
    setShowProductModal(false);
  };
  const productClickHandler = (data) => {
    setShowProductModal(true);
    setProductModalData(data);
    clickOnProduct(data.info.id, 0, rout);
  };
  return (
    <div className="product-list">
      <img src={productTitleImg} className="w-100" />
      <div className="product-list-container gradient ">
        {productListData.map((p, i) => {
          return (
            <ProductItem
              title={p.info.title}
              src={p.info.main_img_src}
              dataProduct={p}
              productClickHandler={productClickHandler}
              key={`mainProductList${i}`}
            />
          );
        })}
      </div>
      <ProductModal
        show={showProductModal}
        closeModal={closeModal}
        name={productModalData?.info?.title}
        productModalData={productModalData?.sub_products}
        clickOnProduct={clickOnProduct}
      />
    </div>
  );
}
